/**
 * 意向等级枚举
 */

export enum IntentLevel {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
  PENDING = 'pending',
}

/** 意向等级展示标签 */
export const INTENT_LEVEL_LABEL: Record<IntentLevel, string> = {
  [IntentLevel.HIGH]: '高',
  [IntentLevel.MEDIUM]: '中',
  [IntentLevel.LOW]: '低',
  [IntentLevel.PENDING]: '待确认',
};

/** 意向等级颜色（前端 Tag 使用） */
export const INTENT_LEVEL_COLOR: Record<IntentLevel, string> = {
  [IntentLevel.HIGH]: 'red',
  [IntentLevel.MEDIUM]: 'orange',
  [IntentLevel.LOW]: 'blue',
  [IntentLevel.PENDING]: 'default',
};
